import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { getActiveSchool } from 'helpers/localstorage';
import { Checkbox, Button } from '@haldor/ui';
import { Search as SearchInput } from 'UI/Inputs';
import { DataList } from 'UI';
import RowItem, { RowCell } from 'UI/Elements/List/RowItem';
import { searchTeacher } from 'actions/search';
import { getUserInfo } from 'actions/user';

var SubjectTeachersForm = /*#__PURE__*/function (_Component) {
  _inherits(SubjectTeachersForm, _Component);

  var _super = _createSuper(SubjectTeachersForm);

  function SubjectTeachersForm(props) {
    var _this;

    _classCallCheck(this, SubjectTeachersForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var promises = [];
      var subjectTeachers = [];

      _this.props.subject.subjectTeachersUserId.forEach(function (userId) {
        promises.push(_this.props.getUserInfo(userId, "base"));
      });

      Promise.all(promises).then(function () {
        _this.props.subject.subjectTeachersUserId.forEach(function (userId) {
          var teacher = _this.props.users.find(function (u) {
            return u.userId == userId;
          });

          if (teacher != null) {
            subjectTeachers.push(teacher);
          }
        });

        _this.setState({
          subjectTeachers: subjectTeachers,
          teachers: subjectTeachers
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      _this.setState({
        loading: true
      });

      _this.props.onSubjectTeachersSubmit(_this.state.subject, _this.state.subjectTeachers);

      _this.setState({
        subjectTeachers: [],
        subject: [],
        loading: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref) {
      var input = _ref.input,
          label = _ref.label,
          type = _ref.type,
          placeholder = _ref.placeholder,
          _ref$meta = _ref.meta,
          touched = _ref$meta.touched,
          error = _ref$meta.error,
          warning = _ref$meta.warning;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({}, input, {
        placeholder: placeholder || label,
        type: type,
        style: touched && error ? {
          border: '1px solid red'
        } : {}
      })), touched && (error && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: '1rem',
          color: 'red'
        }
      }, error) || warning && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: '1rem',
          color: 'red'
        }
      }, warning)));
    });

    _defineProperty(_assertThisInitialized(_this), "onSearchInputChange", function (value) {
      var teachers = [];

      if (value == '') {
        teachers = _this.state.allTeachers;
      } else {
        var activeSchool = getActiveSchool(_this.props.currentUser.id);

        _this.props.searchTeacher(value, activeSchool).then(function () {
          var teachers = _this.props.teachers;
          var allTeachers = _this.props.teachers;

          _this.setState({
            allTeachers: allTeachers,
            teachers: teachers
          });

          teachers = _this.state.allTeachers.filter(function (teacher) {
            var _teacher$firstName, _teacher$lastName;

            return ((_teacher$firstName = teacher.firstName) === null || _teacher$firstName === void 0 ? void 0 : _teacher$firstName.toLowerCase().startsWith(value.toLowerCase())) || ((_teacher$lastName = teacher.lastName) === null || _teacher$lastName === void 0 ? void 0 : _teacher$lastName.toLowerCase().startsWith(value.toLowerCase())) || teacher.email.toLowerCase().startsWith(value.toLowerCase);
          });
        });
      }

      _this.setState({
        teachers: teachers
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectTeacher", function (teacher) {
      if (_this.state.subjectTeachers.findIndex(function (ss) {
        return ss.userId == teacher.userId;
      }) > -1) {
        _this.setState({
          subjectTeachers: _this.state.subjectTeachers.filter(function (t) {
            return t.userId != teacher.userId;
          })
        });
      } else {
        _this.setState({
          subjectTeachers: [].concat(_toConsumableArray(_this.state.subjectTeachers), [teacher])
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderTeacher", function (teacher, index) {
      var teacherIndex = _this.state.subjectTeachers.findIndex(function (u) {
        return u.userId == teacher.userId;
      });

      return /*#__PURE__*/React.createElement(RowItem, {
        key: teacher.userId
      }, /*#__PURE__*/React.createElement(RowCell, {
        shrink: true,
        title: _this.props.translate('name')
      }, /*#__PURE__*/React.createElement(Checkbox, {
        value: teacherIndex > -1,
        onChange: function onChange() {
          return _this.selectTeacher(teacher);
        },
        label: teacher.firstName + " " + teacher.lastName + " (" + teacher.email + ")"
      })));
    });

    var subject = _this.props.subject;
    _this.state = {
      allTeachers: [],
      teachers: [],
      subject: subject,
      subjectTeachers: []
    };
    return _this;
  }

  _createClass(SubjectTeachersForm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          handleSubmit = _this$props.handleSubmit,
          submitting = _this$props.submitting,
          valid = _this$props.valid,
          translate = _this$props.translate;
      return /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginTop: 0
        }
      }, /*#__PURE__*/React.createElement("label", {
        style: {
          marginTop: 0
        }
      }, this.props.translate('search-teacher')), /*#__PURE__*/React.createElement(SearchInput, {
        placeholder: this.props.translate('search'),
        onChange: this.onSearchInputChange,
        autofocus: true,
        lengthLimit: 3
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/React.createElement(DataList, {
        title: translate('teacher'),
        data: this.state.teachers,
        renderRow: this.renderTeacher,
        emptyData: function emptyData() {
          return /*#__PURE__*/React.createElement("div", {
            className: "color--meta text--center weight--bold"
          }, translate('no-results'));
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit",
        style: {
          marginTop: '2em'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "save",
        disabled: submitting || !valid
      }, this.props.translate('save')))));
    }
  }]);

  return SubjectTeachersForm;
}(Component);

function mapStateToProps(state, ownProps) {
  return {
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser,
    teachers: state.Search.teachers,
    users: state.user.info
  };
}

export default connect(mapStateToProps, {
  searchTeacher: searchTeacher,
  getUserInfo: getUserInfo
})(reduxForm({
  form: 'AddTeacherSubject',
  destroyOnUnmount: true
})(SubjectTeachersForm));